function roundTo(
  value: number,
  decimalPlaces: number = 2
) {
  return Number(value.toFixed(decimalPlaces))
}

export default roundTo